import { useState } from 'react';
import { exportApi } from '../../api/export.js';
import { ErrorAlert } from '../../components/common/ErrorAlert.jsx';
import { usePageHeader } from '../../hooks/usePageHeader.jsx';

const EXPORT_TYPES = [
  { type: 'speakers', label: 'Speakers', description: 'All speaker profiles — name, email, organization, contact info, bio, pipeline status, topic, source.' },
  { type: 'events', label: 'Events', description: 'All events — title, date, format, location, status.' },
  { type: 'engagements', label: 'Engagements', description: 'All engagements — speaker, event, topic, format, status, agreement status, dates.' },
  { type: 'checklist', label: 'Checklist summary', description: 'One row per engagement/checklist item — completion status, due date, who completed.' },
  { type: 'communications', label: 'Communication log', description: 'All comm log entries — engagement, type, recipient, date, note.' },
];

export function ExportPage() {
  usePageHeader('Export data', 'Download CSV files for all record types');
  const [downloading, setDownloading] = useState(null);
  const [error, setError] = useState(null);

  const download = async (type) => {
    setDownloading(type);
    try {
      const blob = await exportApi.download(type);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${type}-${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      setError(e.message);
    } finally {
      setDownloading(null);
    }
  };

  return (
    <div className="page-container">
      <p style={{ color: 'var(--color-text-muted)', marginBottom: 'var(--space-6)' }}>
        Files are UTF-8 encoded and compatible with Excel.
      </p>

      <ErrorAlert error={error} onDismiss={() => setError(null)} />

      <div className="stack">
        {EXPORT_TYPES.map(({ type, label, description }) => (
          <div key={type} className="card between" style={{ alignItems: 'center', gap: 'var(--space-4)' }}>
            <div>
              <h3 style={{ fontSize: 'var(--text-base)', fontWeight: 'var(--weight-semibold)', marginBottom: 2 }}>{label}</h3>
              <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>{description}</p>
            </div>
            <button
              className="btn btn-secondary"
              style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
              onClick={() => download(type)}
              disabled={downloading === type}
            >
              {downloading === type ? 'Downloading…' : '⬇ Download CSV'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
